import { OCCUPIED, SEAT_IDS, SEAT_TYPES } from './constants'

export const getSeatType = (seat, tickets) => {
    const seatInBasket = tickets?.find((ticket) => ticket?.seatid === seat?.seatid)

    if (seat?.state === OCCUPIED) {
        // If the seat is in the basket we don't want to show occupied seat when the user unselects the seat - show normal seat based on price_categoryid
        if (seatInBasket) {
            switch (seat?.price_categoryid) {
                case SEAT_IDS.WHEELCHAIR:
                case SEAT_IDS.GOLD_WHEELCHAIR:
                case SEAT_IDS.TDL_WHEELCHAIR:
                case SEAT_IDS.TDL_FAMILY_WHEELCHAIR:
                    return SEAT_TYPES.WHEELCHAIR

                case SEAT_IDS.VIP:
                case SEAT_IDS.ATMOS_VIP:
                    return SEAT_TYPES.VIP
                case SEAT_IDS.VIP_DOUBLE:
                    return SEAT_TYPES.VIP

                case SEAT_IDS.GOLD:
                    return SEAT_TYPES.GOLD

                case SEAT_IDS.TDL:
                    return SEAT_TYPES.DELUXE

                case SEAT_IDS.POSITIONABLE:
                case SEAT_IDS.POSITIONABLE_DOUBLE:
                    return SEAT_TYPES.POSITIONABLE

                default:
                    return SEAT_TYPES.CLASSIC
            }
        }

        return SEAT_TYPES.RESERVED
    }

    switch (seat?.price_categoryid) {
        case SEAT_IDS.WHEELCHAIR:
        case SEAT_IDS.GOLD_WHEELCHAIR:
        case SEAT_IDS.TDL_WHEELCHAIR:
        case SEAT_IDS.TDL_FAMILY_WHEELCHAIR:
            return SEAT_TYPES.WHEELCHAIR

        case SEAT_IDS.VIP:
        case SEAT_IDS.ATMOS_VIP:
            return SEAT_TYPES.VIP
        case SEAT_IDS.VIP_DOUBLE:
            return SEAT_TYPES.VIP

        case SEAT_IDS.GOLD:
            return SEAT_TYPES.GOLD

        case SEAT_IDS.TDL:
            return SEAT_TYPES.DELUXE

        case SEAT_IDS.POSITIONABLE:
        case SEAT_IDS.POSITIONABLE_DOUBLE:
            return SEAT_TYPES.POSITIONABLE

        case SEAT_IDS.BOUTIQUE_WHEELCHAIR:
            return SEAT_TYPES.WHEELCHAIR
        case SEAT_IDS.BOUTIQUE:
            return SEAT_TYPES.BOUTIQUE

        default:
            return SEAT_TYPES.CLASSIC
    }
}

export const getSeatDisabled = (seat, seatType, isSelectedSeat, tickets) => {
    if (isSelectedSeat) return false

    const seatInBasket = tickets?.find((ticket) => ticket?.seatid === seat?.seatid)

    // If the seat is in the basket - do not disable this seat - user can still select/unselect
    // Even though the seat is "OCCUPIED" - it is occupied by user
    if (seatInBasket) return false

    const isOcupied = seat?.state === OCCUPIED

    return isOcupied
}
